import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_neiye from '../views/lanhu_neiye/index.vue'
import lanhu_danchuang from '../views/lanhu_danchuang/index.vue'
import lanhu_kongjian from '../views/lanhu_kongjian/index.vue'
import Index from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/index"
  },
  {
    path: '/index',
    name: '首页',
    component: Index
  },
  {
    path: '/lanhu_neiye',
    name: 'lanhu_neiye',
    component: lanhu_neiye
  },
  {
    path: '/lanhu_danchuang',
    name: 'lanhu_danchuang',
    component: lanhu_danchuang
  },
  {
    path: '/lanhu_kongjian',
    name: 'lanhu_kongjian',
    component: lanhu_kongjian
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
